module.exports = __webpack_public_path__ + "img/office_desk.1b9a52a1.jpg";